<template>
  <div class="flex justify-center gap-3 " >
    <!-- 저장/닫기 -->
    <fragment v-if="editMode">
      <button @click="onClickCloseEditMode">
        <feather-icon icon="CheckIcon" svgClasses="h-5 w-5" />
      </button>
      <button @click="onClickCancel">
        <feather-icon icon="XIcon" svgClasses="h-5 w-5" />
      </button>
    </fragment>
    <!-- 수정/삭제 -->
    <fragment v-else>
      <button @click="onClickOpenEditMode">
        <feather-icon icon="Edit2Icon" svgClasses="h-5 w-5" />
      </button>
      <button :class="{'readonly': !useDelete}" @click="onClickDelete">
        <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5" />
      </button>
    </fragment>
  </div>
</template>

<script>
export default {
  name: "RowEditTool",
  props: {
    value: Boolean,
    data: [Object, Array, String, Number, Boolean],
    useDelete: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    editMode: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    onClickOpenEditMode() {
      this.editMode = true;
      this.$emit("open-edit-mode", this.data);
    },
    onClickCloseEditMode() {
      this.$emit("close-edit-mode", this.data);
    },
    onClickDelete() {
      this.$emit("delete", this.data);
    },
    onClickCancel() {
      this.editMode = false;
      this.$emit("cancel", this.data);
    },
  }
}
</script>

<style lang="scss" scoped>
  button {
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #7e72f2;
    background: none;
    border: 1px solid #7e72f2;
    border-radius: 4px;
    cursor: pointer;

    span {
      margin: 0;
    }

    &.readonly {
      cursor: inherit;
      color: #cdcdcd;
      border: 1px solid #cdcdcd;
    }
  }
</style>
